import { useEffect, useState } from 'react';
import { Metrics } from '../utils/metrics';
import Raven from 'raven-js';
import { apiClientWithMiddleware } from '../api/utils';
function fetchUserInfo() {
  const path = '/login-verify/user-info';
  const clientConfig = {
    maxRetries: 5
  };
  return apiClientWithMiddleware(clientConfig).get(path);
}
const useGetUserData = () => {
  const [userInfo, setUserInfo] = useState(null);
  const GET_USER_INFO_FAILURE = 'render-alerts-failure';
  useEffect(() => {
    fetchUserInfo().then(response => {
      setUserInfo(response);
    }).catch(err => {
      Metrics.counter(GET_USER_INFO_FAILURE).increment();
      Raven.captureException(err);
    });
  }, []);
  return userInfo;
};
export default useGetUserData;